import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=ccf2bf32&scoped=true"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=ccf2bf32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf2bf32",
  null
  
)

export default component.exports